import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Page from "../Page/Page";
import Toast from "../../Utils/Toast";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import LoadingSpinner from "../../Components/Common/LoadingSpinner";
import { Transaction_Profile } from "../../Connections/Transaction";

import "../../Styles/InviteFriends.css";

const InviteFriends = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location?.state?.form;
  // =============================================

  const [invitedList, setInvitedList] = useState([]);
  const [phoneValue, setPhoneValue] = useState();
  const [linkValue, setLinkValue] = useState("");
  const [loading, setLoading] = useState(false);

  // =============================================

  const copyToClipBoard = async (text) => {
    await navigator.clipboard.writeText(text);
    Toast("success", "لینک با موفقیت کپی شد!");
  };

  const handleSubmitInviteWithPhoneForm = (e) => {
    e.preventDefault();
    if (phoneValue.length == 11 && phoneValue.startsWith("09")) {
      setLoading(true);
      const form = new FormData();
      form.append("mobile", phoneValue);
      Transaction_Profile.Invite(form)
        .then((res) => {
          if (res[0]) {
            Toast("success", "دوستت با موفقیت دعوت شد و بعد از ثبت‌نام، امتیازش رو دریافت می‌کنی");
            setPhoneValue("");
          } else {
            Toast("error", res[1]);
            setPhoneValue("");
          }
          setLoading(false);
        })
        .catch((err) => console.log(err));
    } else {
      Toast("error", "شماره موبایلی که وارد کردی معتبر نیست!");
    }
  };

  // =============================================

  useEffect(() => {
    Transaction_Profile.GetInvitees()
      .then((res) => {
        if (res[0]) {
          setLinkValue(
            `https://ketabno.com/register?inviteId=${res[2].data?.inviteUrl}`
          );
          setInvitedList(res[2].data?.invites);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  // =============================================

  return (
    <Page>
      <MobileNavBar text="دعوت از دوستان" action={() => navigate(-1)} />
      <div className="InviteFriends">
        <div
          className="InviteFriends_back-arrow mobile-hidden"
          onClick={() => navigate(-1)}
        >
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
              fill="#ffffff"
            />
          </svg>
        </div>
        <div className="InviteFriends-inside">
          <div className="InviteFriends-inside-item1">
            <div className="InviteFriends-inside-item1-right">
              <div className="InviteFriends-inside-item1-right-inside">
                <p className="InviteFriends-inside-item1-right-inside-text1">
                  دوستات رو به کتابنو دعوت کن
                </p>
                <p className="InviteFriends-inside-item1-right-inside-text2">
                  با دعوت دوستات به کتابنو مدال و امتیاز بگیر...
                </p>
              </div>
            </div>
            <div className="InviteFriends-inside-item1-left">
              <img
                className="InviteFriends-inside-item1-left-img"
                src="/imgs/Profile/InviteFriends.svg"
              />
            </div>
            <div className="InviteFriends-inside-item1-res">
              <div className="InviteFriends-inside-item1-right-inside">
                <p className="InviteFriends-inside-item1-right-inside-text1">
                  دوستات رو به کتابنو دعوت کن
                </p>
                <p className="InviteFriends-inside-item1-right-inside-text2">
                  با دعوت دوستات به کتابنو مدال و امتیاز بگیر...
                </p>
              </div>
            </div>
          </div>

          <div className="InviteFriends-inside-item2">
            <div className="InviteFriends-inside-item2-right">
              <div className="InviteFriends-inside-item2-right-top">
                <p className="InviteFriends-inside-item2-right-top-text">
                  شماره دوستت رو بنویس:
                </p>
              </div>

              <form
                onSubmit={handleSubmitInviteWithPhoneForm}
                className="InviteFriends-inside-item2-right-bottom"
              >
                <input
                  className="InviteFriends-inside-item2-right-bottom-input"
                  type="number"
                  id="Phone"
                  required
                  value={phoneValue}
                  onChange={(e) => setPhoneValue(e.target.value)}
                />
                <label
                  htmlFor="Phone"
                  className="InviteFriends-inside-item2-right-bottom-label"
                >
                  شماره تلفن
                </label>
                <button
                  type="submit"
                  className="InviteFriends-inside-item2-right-bottom-button"
                >
                  {loading ? <LoadingSpinner /> : "ارسال دعوتنامه"}
                </button>
              </form>
              <p className="InviteFriends-inside-item2-right-bottom-error">
                این دوستت رو قبلا یکی دعوت کرده!
              </p>
            </div>
            <div className="InviteFriends-inside-item2-left">
              <div className="InviteFriends-inside-item2-left-top">
                <p className="InviteFriends-inside-item2-right-top-text">
                  یا دوستات رو با لینک اختصاصی دعوت کن:
                </p>
              </div>

              <div className="InviteFriends-inside-item2-left-bottom">
                <input
                  className="InviteFriends-inside-item2-left-bottom-input"
                  type="text"
                  id="Link"
                  required
                  value={linkValue}
                  onChange={(e) => setLinkValue(e.target.value)}
                />
                <img
                  className="InviteFriends-inside-item2-left-bottom-icon"
                  src="/imgs/Profile/bx_link.svg"
                />
                <label
                  htmlFor="Link"
                  className="InviteFriends-inside-item2-left-bottom-label"
                >
                  لینک اختصاصی
                </label>
                <button
                  className="InviteFriends-inside-item2-left-bottom-button"
                  onClick={() => copyToClipBoard(linkValue)}
                >
                  کپی لینک
                </button>
              </div>
            </div>
          </div>

          <div className="InviteFriends-inside-item3">
            <div className="InviteFriends-inside-item3-top">
              <p className="InviteFriends-inside-item3-top-text">
                کارنامه دعوت
              </p>
              <div className="InviteFriends-inside-item3-top-border"></div>
            </div>
            <div className="InviteFriends-inside-item3-bottom">
              {/* map */}
              {invitedList.map((item, index) => (
                <div className="boxFriends" key={item.id}>
                  <div className="InviteFriends-inside-item3-bottom-boxFriends">
                    <div className="InviteFriends-inside-item3-bottom-boxFriends-inside">
                      <div className="InviteFriends-inside-item3-bottom-boxFriends-inside-item1">
                        {/* <div className="InviteFriends-inside-item3-bottom-boxFriends-inside-item1-right">
                          <img
                            className="InviteFriends-inside-item3-bottom-boxFriends-inside-item1-right-img"
                            src="/imgs/Profile/imgFriends.svg"
                          />
                        </div> */}
                        <div className="InviteFriends-inside-item3-bottom-boxFriends-inside-item1-left">
                          <div className="InviteFriends-inside-item3-bottom-boxFriends-inside-item1-left-top">
                            <p style={{ marginLeft: "4px" }}>{index + 1}- </p>
                            <p className="InviteFriends-inside-item3-bottom-boxFriends-inside-item1-left-top-text">
                              دوست
                            </p>
                            <span className="InviteFriends-inside-item3-bottom-boxFriends-inside-item1-left-top-textNumbeer number-font">
                              {item.id}
                            </span>
                          </div>
                          <p className="InviteFriends-inside-item3-bottom-boxFriends-inside-item1-left-bottom number-font">
                            {item.mobile}
                          </p>
                        </div>
                      </div>

                      <div className="InviteFriends-inside-item3-bottom-boxFriends-inside-item2">
                        <div className="InviteFriends-inside-item3-bottom-boxFriends-inside-item2-inside">
                          <p className="InviteFriends-inside-item3-bottom-boxFriends-inside-item2-right">
                            تاریخ دعوت
                          </p>
                          <p className="InviteFriends-inside-item3-bottom-boxFriends-inside-item2-left number-font">
                            {item.date}
                          </p>
                        </div>
                        <div className="InviteFriends-inside-item3-bottom-boxFriends-inside-item2-inside">
                          <p className="InviteFriends-inside-item3-bottom-boxFriends-inside-item2-right">
                            امتیاز دریافتی
                          </p>
                          <p className="InviteFriends-inside-item3-bottom-boxFriends-inside-item2-left number-font">
                            {item.score}
                          </p>
                        </div>
                        <div className="InviteFriends-inside-item3-bottom-boxFriends-inside-item2-inside">
                          <p className="InviteFriends-inside-item3-bottom-boxFriends-inside-item2-right">
                            سکه دریافتی
                          </p>
                          <p className="InviteFriends-inside-item3-bottom-boxFriends-inside-item2-left number-font">
                            {item.coin}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};
export default InviteFriends;
